import MultiSelectInput from '@repo/ui/multiselect-input'
import RadioInput from '@repo/ui/radio-input'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../lib/hooks/use-translate'
import { FieldStatusEnum } from '../../../lib/types/enums/affected-staff/field-status.enum'
import {
  StaffPositionEnum,
  staffPositionEnumMapping
} from '../../../lib/types/enums/staff/staff-position.enum'
import { StaffCoordinatesFilters } from '../../../lib/types/models/staff/staff'

interface Props {
  filter?: StaffCoordinatesFilters
  onFilterChange: (filter: StaffCoordinatesFilters) => void
}

const StaffCoordinatesFilter = ({ filter, onFilterChange }: Props) => {
  const { t } = useTranslate()
  function setFilter<K extends keyof StaffCoordinatesFilters>(
    key: K,
    value: StaffCoordinatesFilters[K]
  ) {
    onFilterChange({ ...filter, [key]: value })
  }
  return (
    <div className={'flex flex-col gap-3 mt-2'}>
      <MultiSelectInput
        label={'Poste'}
        variant={'primary'}
        searchable
        options={Object.values(StaffPositionEnum).map((position) => ({
          label: t(staffPositionEnumMapping[position]),
          value: position
        }))}
        onChange={(positions) => setFilter('position', positions)}
        selectedOptions={filter?.position?.map((position) => ({
          label: t(staffPositionEnumMapping[position]),
          value: position
        }))}
      />
      <div className="flex flex-col ">
        <Typography variant="body-medium" className="mb-2">
          Statut
        </Typography>
        <div className="flex items-center gap-5 ">
          <RadioInput
            checked={!filter?.ibanStatus}
            label="Tous"
            onCheck={() => setFilter('ibanStatus', undefined)}
          />
          <RadioInput
            checked={filter?.ibanStatus?.includes(FieldStatusEnum.NEW)}
            label="Nouveau"
            onCheck={() => setFilter('ibanStatus', [FieldStatusEnum.NEW])}
          />
          <RadioInput
            checked={filter?.ibanStatus?.includes(FieldStatusEnum.CHANGED)}
            label="Changement IBAN"
            onCheck={() => setFilter('ibanStatus', [FieldStatusEnum.CHANGED])}
          />
        </div>
        <div className="h-2" />
        <div className="flex flex-col ">
          <Typography variant="body-medium" className="mb-2">
            Exporté
          </Typography>
          <div className="flex items-center gap-5 ">
            <RadioInput
              checked={filter?.ibanExported === undefined}
              label="Tous"
              onCheck={() => setFilter('ibanExported', undefined)}
            />
            <RadioInput
              checked={filter?.ibanExported === true}
              label="Oui"
              onCheck={() => setFilter('ibanExported', true)}
            />
            <RadioInput
              checked={filter?.ibanExported === false}
              label="Non"
              onCheck={() => setFilter('ibanExported', false)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default StaffCoordinatesFilter
